export const Path = Object.freeze({
    home: '/',
    product: '/product',
    pay: '/pay',
    orders: '/orders',
    shoppingCart: '/cart',
    shippingAddress: '/address',
    profile: '/profile',
})